import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'procurement',
  children: {
    purchaseRequests: {
      path: 'purchase-requests',
      size: 'full',
      children: {
        detail: {
          path: ':id',
          size: 'full',
          children: {
            summary: {
              path: 'summary',
              size: 'full',
            },
            attachments: {
              path: 'attachments',
              size: 'full',
            },
            comments: {
              path: 'comments',
              size: 'full',
            },
          },
        },
      },
    },
    purchaseOrders: {
      path: 'purchase-orders',
      size: 'full',
      children: {
        detail: {
          path: ':id',
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
